import React from 'react'

import editIcon from '../../assets/svg/write.svg'

import IProps from './props'
import {
  Container, Content, HeaderCard, Span, EditDiv, Span2,
} from './styles'

const CardProfile = ({
  title,
  subtitle,
  content,
  cancelEdit,
  isEditing,
  handleEditClick,
  children,
  showEdit = true,
}: IProps) => (
  <Container>
    <HeaderCard>
      <div>
        <Span>{title}</Span>
        <Span2>{subtitle}</Span2>
      </div>
      {isEditing ? (
        <EditDiv onClick={cancelEdit}>
          <span>Cancelar</span>
        </EditDiv>
      ) : (
        showEdit && (
          <EditDiv onClick={handleEditClick}>
            <img src={editIcon} alt="Editar" />
            Editar
          </EditDiv>
        )
      )}
    </HeaderCard>
    <Content>{content}</Content>
    {children && <Content>{children}</Content>}
  </Container>
)

export default CardProfile
